// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3jOLT","content":"Consent_content__2tjn0","footer":"Consent_footer__1dQmB"};